import { useContext } from 'react';
import { validateFieldPathContext } from './context';

export const useShouldValidateFieldPath = () => {
  const shouldValidateFieldPath = useContext(validateFieldPathContext);
  return shouldValidateFieldPath;
};
